import { IAppState } from '../../common/state';
import { EBuildingStatus } from '../../repositories/common/json_query';

export function getIsHousesFilterEnabled({ filters }: IAppState): boolean {
  return (filters.jsonQuery.building_status || { value: undefined }).value === EBuildingStatus.New;
}
